import type {
  AddNameToGroupDTOType,
  AddUserToGroupDTOType,
  CreateGroupDTOType,
  CreateGroupResponseType,
  MatchingExplanationsType,
  RemoveUserFromGroupDTOType,
} from '@/features/admin/groups/types'
import fetchClient from '@/lib/fetch'

export function addNameToGroupMutation(data: AddNameToGroupDTOType): Promise<any> {
  return fetchClient(`/v2/groups/${data.groupId}/name`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export function addUserToGroupMutation(data: AddUserToGroupDTOType): Promise<any> {
  return fetchClient(`/v2/groups/${data.groupId}/user/${data.userId}`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export function removeUserFromGroupMutation(data: RemoveUserFromGroupDTOType): Promise<any> {
  return fetchClient(`/v2/groups/${data.groupId}/user/${data.userId}`, {
    method: 'DELETE',
  })
}

export function createGroupMutation(data: CreateGroupDTOType): Promise<CreateGroupResponseType> {
  return fetchClient(`/v2/groups`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export const getMatchingExplanationBetweenMentorAndMentee = (data: {
  menteeId: string
  groupId: string
}): Promise<{ mentor: MatchingExplanationsType }> => {
  return fetchClient(`/v2/groups/matching-explanation`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}
